import { CameraData } from "@centricsoftware/model-viewer";
import EditController from "csi/action/EditController";
import { routerStore } from "csi/state/rootStore";
import CameraPositionDialogStore from "csi/threeD/cameraPositions3D/CameraPositionStore";
import NewCameraPositionDialog from "csi/threeD/cameraPositions3D/NewCameraPositionDialog";
import declare from "dojo/_base/declare";

const EditCameraPosition = declare(EditController, {
	/**
	 * @override
	 * Open React dialog
	 */
	preProcess(): void {
		const {
			$Name: name,
			$URL: url,
			Description: description,
			Location: location,
			Rotation: rotation,
			Active: active,
		  } = this.getNode();

		const cameraData: CameraData = {
			position: location,
			rotation: rotation,
		};

		const exisitngCameraPositionData = {
			cameraData,
			description,
			name,
			url,
			active,
		};

		const onSave = async (jsonResponse: Promise<void>): Promise<void> => {
			this.processReact(jsonResponse);
		};	

		const onCancel = (): void => {
			this.onCancelReactDialog();
		};

		const store = new CameraPositionDialogStore(onSave, onCancel, this.m_writer, this, exisitngCameraPositionData );
		this.useReactDialog(routerStore.openDialog(NewCameraPositionDialog, { store }));
	},
});

export = EditCameraPosition;